
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ScrollText } from "lucide-react";

interface EmptyStateProps {
  searchQuery: string;
  onClearSearch: () => void;
}

export const EmptyState = ({ searchQuery, onClearSearch }: EmptyStateProps) => {
  return (
    <Card className="p-12 border-dashed border-2 border-accent-light/40">
      <CardContent className="flex flex-col items-center justify-center text-center space-y-4 p-0">
        <div className="bg-accent-light/20 p-4 rounded-full">
          <ScrollText className="h-12 w-12 text-accent" />
        </div>
        <h3 className="text-xl font-title font-medium text-primary">No courses found</h3>
        <p className="text-muted-foreground font-subtitle text-sm max-w-md">
          {searchQuery 
            ? `We couldn't find any courses matching "${searchQuery}"`
            : "There are no available courses at this time. Check back later for new offerings."
          }
        </p>
        {searchQuery && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onClearSearch}
            className="mt-2 font-section"
          >
            Clear search
          </Button>
        )}
      </CardContent>
    </Card>
  );
};
